module.exports = __webpack_public_path__ + "img/im_scrollfeature_02.0fd0582b.jpg";